<template>
<!--About Us Section-->
    <b-container class="about-section">
     <b-row align-v="center">
      <b-col md="6"> 
        <h2> About Our Store</h2>
        <p>Welcome to our leather store, where we offer a wide range of high-quality leather products. Our collection includes bags, wallets, belts, and accessories crafted from the finest materials. We take pride in our craftsmanship and attention to detail, ensuring that each product is not only stylish but also durable. Whether you're looking for a classic leather bag or a unique accessory, we have something for everyone. Explore our store and discover the perfect leather piece to complement your style.</p>
        <router-link to="/about" class="about-button">Learn More</router-link>
      </b-col>

    <b-col md="6">
        <b-img
          :src="leatherCraft3"
          alt="About Us Image"
          class="img-fluid"
        ></b-img>
      </b-col>
    </b-row>
  </b-container>
    </template>

 <script>
import leatherCraft3 from '@/assets/leathercraft3.webp'

export default {
  name: 'AboutPage',

  data() {
    return {
      leatherCraft3
    }
  }
}
</script>

    <style scoped>
   .about-section {
        padding: 70px 8%;
        background-color: #f5f0e8;
      }
    .about-button {
        background-color: #b65f4a;
        border-color: #b65f4a;
        color: #ffffff;
        padding: 10px 25px;
        text-decoration: none;
        font-size: 16px;
      }
    </style>